import { Menu } from 'lucide-react';

import { getVisibleAdminNavItems, type AdminNavItem } from '@/platform/features/admin/adminNav';
import type { BottomTab, QuickAction, SidebarItem, TemplateConfig } from '../catedge';

function slugify(value: string): string {
  return value
    .replace(/[^a-z0-9]+/gi, '-')
    .replace(/^-|-$/g, '')
    .toLowerCase();
}

function compactAdminLabel(item: AdminNavItem): string {
  switch (item.href) {
    case '/admin':
      return 'Home';
    case '/admin/content':
      return 'Content';
    case '/admin/publishing':
      return 'Publish';
    case '/admin/users':
      return 'Users';
    case '/admin/settings':
      return 'Settings';
    default:
      return item.label;
  }
}

function toSidebarItem(item: AdminNavItem): SidebarItem {
  return {
    id: slugify(item.href),
    label: item.label,
    icon: item.icon,
    path: item.href,
  };
}

function toQuickAction(item: AdminNavItem): QuickAction {
  return {
    label: item.label,
    to: item.href,
  };
}

function toBottomTab(item: AdminNavItem): BottomTab {
  return {
    id: slugify(item.href),
    label: compactAdminLabel(item),
    icon: item.icon,
    to: item.href,
  };
}

export function createAdminShellConfig(capabilities: string[]): TemplateConfig {
  const visibleItems = getVisibleAdminNavItems(capabilities);
  const docsRoute =
    visibleItems.find((item) => item.href === '/admin/settings')?.href ??
    visibleItems.at(-1)?.href ??
    '/admin';

  return {
    brand: {
      name: 'WhatImean Operations',
      shortName: 'W',
      logoSrc: '/WIMLogo-trans1.png',
      logoAlt: 'WhatImean logo',
      versionLabel: 'Admin',
    },
    tenancy: 'enabled',
    adminRole: 'admin',
    navigation: visibleItems.map(toSidebarItem),
    quickActions: visibleItems.slice(0, 4).map(toQuickAction),
    bottomTabs: [
      ...visibleItems.slice(0, 3).map(toBottomTab),
      {
        id: 'menu',
        label: 'Menu',
        icon: Menu,
        action: 'menu',
      },
    ],
    routes: {
      login: '/login',
      dashboard: '/admin',
      docs: docsRoute,
    },
    appEnv: import.meta.env.MODE || 'development',
  };
}
